import { trackCmsEvent, trackExperimentEvent } from '.';
import type { CmsInfo } from './types';

// https://dataportal.zillowgroup.net/event-registry/2284
export const emitPageEvent = (cmsInfo: CmsInfo['cms_info']) =>
  trackCmsEvent({
    envelope: {
      event_type_id: '2284',
      event_type_version_id: '1',
      event_template_id: '126',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'view',
      trigger_location_nm: 'cms',
      trigger_source_nm: 'cms',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: [],
    },
    cms_info: cmsInfo,
  });

// https://dataportal.zillowgroup.net/event-registry/5485
export const emitExperimentEvent = ({
  keyType,
  randomizationKey,
  treatments,
}: {
  keyType: string;
  randomizationKey: string;
  treatments: Array<string>;
}) =>
  trackExperimentEvent({
    envelope: {
      event_type_id: '5485',
      event_type_version_id: '1',
      event_template_id: '3',
      event_template_version_id: '1',
    },
    semantic: {
      semantic_event_nm: 'optimizely_exposure',
      topic_tag_txt: ['cms', 'optimizely'],
    },
    exposure: {
      assignment_service_cd: 'optimizely',
      key_type_cd: keyType,
      randomization_key: randomizationKey,
      treatment_nm: treatments,
    },
  });
